// employer
import {
  employerPOCMappingTo9141SectionB,
  employerMappingTo9141SectionC,
} from "./employer/mapping/employer_9141";
import {
  employerPOCMappingTo9141CSectionB,
  employerMappingTo9141CSectionC,
} from "./employer/mapping/employer_9141C";
import {
  agentToEmployerPOCMappingTo9142BSectionD,
  employerMappingTo9142BSectionD,
} from "./employer/mapping/employer_9142B";
import {
  employerPOCMappingTo790SectionII,
  employerMappingTo790SectionII,
} from "./employer/mapping/employer_790";
import {
  employerPOCMappingTo9142ASectionC,
  employerMappingTo9142ASectionB,
} from "./employer/mapping/employer_9142A";
import {
  employerMappingTo9035SectionC,
  employerPOCMappingTo9035SectionD,
} from "./employer/mapping/employer_9035";
import {
  employerMappingTo9089SectionA,
  employerPOCMappingTo9089SectionB,
} from "./employer/mapping/employer_9089";

// agent-attorney
import { agentAttorneyMappingTo9141SectionD } from "./agent_attorney/mapping/agent_attorney_9141";
import { agentAttorneyMappingTo9142BSectionE } from "./agent_attorney/mapping/agent_attorney_9142B";
import { agentAttorneyMappingTo9142ASectionD } from "./agent_attorney/mapping/agent_attorney_9142A";
import { agentAttorneyMappingTo9035SectionE } from "./agent_attorney/mapping/agent_attorney_9035";
import { agentAttorneyMappingTo9089SectionC } from "./agent_attorney/mapping/agent_attorney_9089";

// foreignLabor
import { foreignLaborRecruiterMappingTo9142BAppxC } from "./foreign_labor_recruiter/mapping/foreign_labor_recruiter_9142B";

// foreignWorker
import { foreignWorkerMappingTo9089AppxA } from "./foreign_worker/mapping/foreign_worker_9089";

const FormUISchemaResolver = (formName) => {
  const uischemas = {
    //9141_old
    // 'employer-pocs-9141_old': employerPOCMappingTo9141SectionB,
    // 'employer-9141_old': employerMappingTo9141SectionC,
    // 'agent-attorney-9141_old': agentAttorneyMappingTo9141SectionB,

    //9141
    "employer-pocs-9141": employerPOCMappingTo9141SectionB,
    "employer-9141": employerMappingTo9141SectionC,
    "agent-attorney-9141": agentAttorneyMappingTo9141SectionD,

    //9141C
    "employer-pocs-9141C": employerPOCMappingTo9141CSectionB,
    "employer-9141C": employerMappingTo9141CSectionC,

    //9142B
    "employer-pocs-9142B": employerMappingTo9142BSectionD,
    "agent-to-employer-pocs-9142B": agentToEmployerPOCMappingTo9142BSectionD,
    "agent-attorney-9142B": agentAttorneyMappingTo9142BSectionE,
    "foreign-labor-9142B": foreignLaborRecruiterMappingTo9142BAppxC,

    //790
    "employer-pocs-790A": employerPOCMappingTo790SectionII,
    "employer-790A": employerMappingTo790SectionII,

    //9142A
    "employer-9142A": employerMappingTo9142ASectionB,
    "employer-pocs-9142A": employerPOCMappingTo9142ASectionC,
    "agent-attorney-9142A": agentAttorneyMappingTo9142ASectionD,

    //9035
    "employer-9035": employerMappingTo9035SectionC,
    "employer-pocs-9035": employerPOCMappingTo9035SectionD,
    "agent-attorney-9035": agentAttorneyMappingTo9035SectionE,

    // 9089
    "employer-9089": employerMappingTo9089SectionA,
    "employer-pocs-9089": employerPOCMappingTo9089SectionB,
    "agent-attorney-9089": agentAttorneyMappingTo9089SectionC,
    "foreign-worker-9089": foreignWorkerMappingTo9089AppxA,
  };
  return uischemas[formName];
};

export default FormUISchemaResolver;
